import BaseStore from './BaseStore'

class SessionStore extends BaseStore {
  accessToken () {
    return window.localStorage.accessToken
  }

  parseResource (data) {
    super.parseResource(data)
    if (['servicerequest', 'admin', 'dealer', 'employee'].includes(data.user.role)) {
      // if employee, only allow certain subRoles
      if (data.user.role === 'employee' && !['director_of_sales', 'regional_vp_of_sales', 'national_sales_coordinator'].includes(data.user.subRole)) {
        return
      }

      window.localStorage.accessToken = data.accessToken
      window.localStorage.userId = data.user.id
    }
  }
}

export default SessionStore
